import React, { Fragment } from 'react'

import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'

import messages from './messages'
import s from './Info.scss'


const CartOrderItemInfo = (props) => {
  const { name, category, type, amount, volume, volumeNotes, volumeUnit, isLocked, isGiftSet } = props

  const brand               = !props.brand && isGiftSet ? 'Gift Set' : props.brand // eslint-disable-line
  const isBeautyBag         = type === 'Bag'
  const isCategoryVisible   = category && !isGiftSet

  return (
    <Fragment>
      <div className={s.brand}>{brand}</div>
      <div className={s.name}>
        {
          Boolean(isBeautyBag && amount > 1) && (
            <span>{amount} x&nbsp;</span>
          )
        }
        {name}
      </div>
      {
        isCategoryVisible && (
          <div className={s.category}>{category}</div>
        )
      }
      {
        typeof isLocked === 'boolean' && (
          <Box mt="4">
            <Text
              message={isLocked ? messages.locked : messages.unlocked}
              uppercase
              color="brand"
            />
          </Box>
        )
      }
      {
        Boolean(volume && volumeNotes && volumeUnit) && (
          <div className={s.volume}>{volume} {volumeUnit} ({volumeNotes})</div>
        )
      }
    </Fragment>
  )
}


export default CartOrderItemInfo
